import styled, { css } from 'styled-components'

import { Colors } from '@fourthwall/components'

import type { RoundedButtonSize } from './RoundedButton.types'

export const Button = styled.button<{ size: RoundedButtonSize }>`
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  border: 1px solid ${Colors.GS1000};
  border-radius: 100px;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  user-select: none;

  &:hover {
    border-color: ${Colors.B500};
    color: ${Colors.B500};
  }

  ${({ size }) =>
    size === 'small' &&
    css`
      height: 32px;
      padding: 4px 10px;
    `}

  ${({ size }) =>
    size === 'medium' &&
    css`
      height: 32px;
      padding: 4px 14px;
    `}

  ${({ size }) =>
    size === 'large' &&
    css`
      height: 42px;
      padding: 8px 20px;
    `}
`
